import HOC from "../../components/HOC";
import DefectaList from "../../components/screen/defecta/DefectaList";
import PageTemplateNew from "../../components/common/particles.jsx/PageTemplateNew";
import BreadcrumbDefecta from "../../components/screen/defecta/defectaComponents/BreadcrumbDefecta";

const DefectaPage = ({ isWarehouse }) => {
  return (
    <PageTemplateNew
      header={`Defecta ${isWarehouse ? "Central Warehouse" : ""}`}
      mainComponent={<DefectaList isWarehouse={isWarehouse} />}
      pageRole={isWarehouse ? 49 : 48}
      breadcrumb={
        <BreadcrumbDefecta isWarehouse={isWarehouse ? isWarehouse : false} />
      }
    />
  );
};

export default HOC(DefectaPage);
